import React, { Component } from 'react';
import { string, array } from 'prop-types';
import classnames from 'classnames/bind';

import { Consumer } from './FormField';
import Input from './Input';
import WithValidation from './WithValidation';
import InputLabel from 'elements/Inputs/InputLabel';
import ValidationsNoteDisplayer from 'elements/Inputs/ValidationsNoteDisplayer';

import styles from './PasswordInput.css';
import formFieldStyles from './FormField.css';

const cx = classnames.bind(styles);

export default class PasswordInput extends Component {
  static propTypes = {
    placeholder: string,
    customClasses: string,
    validations: array,
    label: string,
  };

  static defaultProps = {
    placeholder: 'Enter password',
    customClasses: ''
  };

  state = { value: '', type: 'password' };

  handleChange = e => {
    this.setState({ value: e.currentTarget.value });
  }

  handleTogglePassword = () => {
    const { type } = this.state;

    if (type === 'password') {
      this.setState({ type: 'text' });
    } else {
      this.setState({ type: 'password' });
    }
  }

  render() {
    const { placeholder, customClasses, validations, label } = this.props;
    const { value, type } = this.state;
    const wrapperClasses = cx({ isFilled: value.length }, 'full-width');
    const iconCustomClasses = cx(formFieldStyles.iconRight, {
      passwordVisible: type === 'text'
    });

    const actionIconProps = {
      icon: 'view',
      type: '20',
      customClasses: iconCustomClasses
    };

    return (
      <div className={wrapperClasses}>
        <Consumer>
          {sharedProps =>
            <WithValidation
              value={value}
              validations={validations}
              render={
                error => (
                  <div className={sharedProps.styles.inputWrapper}>
                    <InputLabel {...sharedProps} label={label} />
                    <Input
                      sharedProps={sharedProps}
                      customClasses={`${customClasses} ${styles.passwordInput}`}
                      placeholder={placeholder}
                      onChange={this.handleChange}
                      value={value}
                      error={error}
                      type={type}
                      actionIcon={actionIconProps}
                      onIconClick={this.handleTogglePassword}
                    />
                    <ValidationsNoteDisplayer
                      styles={sharedProps.styles}
                      error={error}
                      darkBg={sharedProps.darkBg}
                    />
                  </div>
                )
              }
            />
          }
        </Consumer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/PasswordInput.js